import {
  getAuth,
  signOut,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  User,
} from 'firebase/auth';
import firebaseApp from './app';
import { isFrontendAdmin } from './database';

const getFirebaseAuth = async () => getAuth(await firebaseApp);

const auth = getFirebaseAuth();

export type UserDataChangedCallback = (
  newUserData: (User & { isFrontendAdmin: boolean }) | null,
) => unknown;

export const signin = async (
  email: string,
  password: string,
): Promise<void> => {
  const authInstance = await auth;
  await signInWithEmailAndPassword(authInstance, email, password);
};

export const signout = async (): Promise<void> => {
  const authInstance = await auth;
  await signOut(authInstance);
};

export const registerForAuthChange = async (
  callback: UserDataChangedCallback,
): Promise<void> => {
  onAuthStateChanged(await auth, async user => {
    if (!user) callback(user);
    else {
      callback({
        ...user,
        isFrontendAdmin: await isFrontendAdmin(user.uid),
      });
    }
  });
};

export const getIdToken: () => Promise<string | undefined> = async () =>
  (await auth)?.currentUser?.getIdToken(true);

export default auth;
